import apiService from '@/services/apiService';

const actions = {
  getPaxelBigExcellences({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-big/excellence/find-with-paging', payload)
        .then((response) => {
          commit('getPaxelBigExcellences', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPaxelBigExcellence({ commit }, payload) {
    apiService.get(`paxel-big/excellence/${payload}`)
      .then((response) => {
        commit('getPaxelBigExcellence', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  orderPaxelBigExcellence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-big/excellence/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postPaxelBigExcellence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-big/excellence', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateStatusPaxelBigExcellence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-big/excellence/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putPaxelBigExcellence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxel-big/excellence/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delPaxelBigExcellence({ commit }, payload) {
    apiService.delete(`paxel-big/excellence/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
